import { RouteObject } from 'react-router-dom'
import { PageLayout } from '$components/common'
import { default as Public } from '.'

export const publicRoutes: RouteObject[] = [
  {
    path: '/oauth/approval',
    element: (
      <PageLayout title="Authorize" htmlTitleOnly>
        <Public.Authorize.Component />
      </PageLayout>
    ),
    loader: Public.Authorize.Loader,
  },
  {
    path: '/oauth/error',
    element: (
      <PageLayout title="Authorize" htmlTitleOnly>
        <Public.OauthError.Component />
      </PageLayout>
    ),
    loader: Public.OauthError.Loader,
  },
  {
    path: '/login',
    element: (
      <PageLayout title="Sign in" htmlTitleOnly>
        <Public.Login.Component />
      </PageLayout>
    ),
    loader: Public.Login.Loader,
  },
  {
    path: '/sign-up',
    element: (
      <PageLayout title="Sign up" htmlTitleOnly>
        <Public.Register.Component />
      </PageLayout>
    ),
    loader: Public.Register.Loader,
  },
  {
    path: '/sign-up/xero',
    element: (
      <PageLayout title="Sign up with Xero" htmlTitleOnly>
        <Public.SignUpXero.Component />
      </PageLayout>
    ),
    loader: Public.SignUpXero.Loader,
  },
  {
    path: '/forgot-password',
    element: (
      <PageLayout title="Forgot password" htmlTitleOnly>
        <Public.ForgotPassword.Component />
      </PageLayout>
    ),
    loader: Public.ForgotPassword.Loader,
  },
  {
    path: '/reset-password',
    element: (
      <PageLayout title="Reset password" htmlTitleOnly>
        <Public.ResetPassword.Component />
      </PageLayout>
    ),
    loader: Public.ResetPassword.Loader,
  },
  {
    path: '/invite',
    element: (
      <PageLayout title="Accept invited" htmlTitleOnly>
        <Public.InvitedToCompany.Component />
      </PageLayout>
    ),
    loader: Public.InvitedToCompany.Loader,
  },
]
